<template>
  <div>
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          v-if="popup == 'check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess
          v-if="popup == 'success'"
          :text="successText"
          @check="poupupEnter"
        ></PopupSuccess>
        <PopupError
          v-if="popup == 'error'"
          :text="successText"
          @check="poupupEnter"
        ></PopupError>
      </Popup>
    </MyTransition>
    <div class="construction_top flex flex_between">
      <div>
        <button
          class="btn_error"
          @click="goAdd('applyConstruction', ['urgent', 'development'])"
        >
          <i class="el-icon-warning"></i> 申請緊急搶修
        </button>
      </div>
      <div class="addConstruction flex">
        <button
          class="btn_border_black"
          @click="goAdd('applyConstruction', ['development'])"
        >
          申請施工單
        </button>
        <button class="btn_primary" @click="goAdd('de_applyConstruction')">
          申請施工單
        </button>
      </div>
    </div>
    <ConstructionList pageRole="department"></ConstructionList>
  </div>
</template>
<style lang="scss">
.construction_top {
  align-items: center;
  .addConstruction {
    > button {
      margin-left: 8px;
    }
  }
}
</style>

<script>
import ConstructionList from "@/components/ConstructionList";
export default {
  name: "adming-construction",
  components: {
    ConstructionList,
  },
  data() {
    return {
      popupStatus: false,
    };
  },
  methods: {
    goAdd(path, type) {
      this.$router.push({
        name: path,
        query: {
          type: type,
        },
      });
    },
  },
};
</script>